import { FC } from 'react';
import { Box, BoxProps } from '@mui/material';

/**
 * @summary Обёртка для тех элементов, под которые не сделаны отдельные компоненты,
 * и в теме нельзя переопределить стили, а отступы у них должны быть.
 */
export const SpacingWrapper: FC<BoxProps> = ({ children, ...restProps }) => (
  <Box my={1} {...restProps}>
    {children}
  </Box>
);
